export const APP_FILE_EVENTS_ROUTE = "/events";
